import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { IconToggle, IconToggleLabelPlacement } from '..';
import { VisualTestContainer } from '../../test/visual/VisualTestContainer';
import { Favorite, FavoriteFill } from '@wix/wix-ui-icons-common/on-stage';
import { classes } from './IconToggle.visual.st.css';
import { VisualAsync } from '../../test/visual/VisualAsync';
import { snap, story, visualize } from 'storybook-snapper';
import { iconToggleDriverFactory } from './IconToggle.driver';

class IconToggleVisual extends React.Component<any> {
  render() {
    return (
      <VisualTestContainer>
        <IconToggle
          checkedIcon={<FavoriteFill />}
          icon={<Favorite />}
          {...this.props}
        />
        <IconToggle
          checkedIcon={<FavoriteFill />}
          icon={<Favorite />}
          {...this.props}
          checked
        />
        <IconToggle
          checkedIcon={<FavoriteFill />}
          icon={<Favorite />}
          {...this.props}
          disabled
        />
      </VisualTestContainer>
    );
  }
}

const tests = [
  {
    describe: 'basic',
    its: [
      {
        it: 'default',
        props: {},
      },
    ],
  },
  {
    describe: 'label',
    its: [
      {
        it: 'default (placement END)',
        props: {
          label: 'Star',
        },
      },
      {
        it: 'placement START',
        props: {
          label: 'Star',
          labelPlacement: IconToggleLabelPlacement.START,
        },
      },
    ],
  },
];

tests.forEach(({ describe, its }) => {
  its.forEach(({ it, props }) => {
    storiesOf(`IconToggle/${describe}`, module).add(it, () => (
      <IconToggleVisual {...props} />
    ));
  });
});

storiesOf('IconToggle/stylesOverrides', module).add('default', () => (
  <IconToggleVisual className={classes.root} />
));

visualize('IconToggle', () => {
  story('focus', () => {
    const its = ['some label', undefined].map((label) => ({
      it: label ?? 'no label',
      props: { label },
    }));
    its.forEach(({ it, props }) =>
      snap(it, (done) => (
        <VisualAsync
          driverFactory={iconToggleDriverFactory}
          onDone={done}
          action={(driver) => driver.click()}
        >
          <IconToggle icon={<Favorite />} checked {...props} />
        </VisualAsync>
      )),
    );
  });

  story('wst variables', () => {
    const WstTest = ({
      variables,
    }: {
      variables: Record<`--wst-${string}`, string>;
    }) => {
      return (
        <div style={{ ...variables }}>
          <IconToggle
            icon={<Favorite />}
            checkedIcon={<FavoriteFill />}
            label="unchecked"
            animation
          ></IconToggle>
          <IconToggle
            icon={<Favorite />}
            checkedIcon={<FavoriteFill />}
            checked
            label="checked"
          ></IconToggle>
          <IconToggle
            icon={<Favorite />}
            checkedIcon={<FavoriteFill />}
            disabled
            label="disabled"
          ></IconToggle>
          <IconToggle
            icon={<Favorite />}
            disabled
            checked
            label="checked disabled"
          ></IconToggle>
        </div>
      );
    };
    snap('paragraph 2', () => (
      <WstTest
        variables={{
          '--wst-paragraph-2-color-rgb': '0,255,0',
          '--wst-paragraph-2-font-variant': 'small-caps',
          '--wst-paragraph-2-font-style': 'italic',
          '--wst-paragraph-2-font-size': '22px',
          '--wst-paragraph-2-font-family': 'Libre Baskerville',
          '--wst-paragraph-2-font-weight': '900',
        }}
      />
    ));
  });
});
